import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params } from '@angular/router';

export function injectQueryParams(): Signal<Params> {
  const activatedRoute = inject(ActivatedRoute);
  return toSignal(activatedRoute.queryParams, { initialValue: {} as Params });
}
